// extracted by mini-css-extract-plugin
var _1 = "LoginSignupLayout-module__content___hkmZG";
var _2 = "LoginSignupLayout-module__form___RvobY";
var _3 = "LoginSignupLayout-module__img___J3DZ6";
var _4 = "LoginSignupLayout-module__picture___VFCfp";
export { _1 as "content", _2 as "form", _3 as "img", _4 as "picture" }
